import {computed} from 'vue'
import {useUserStore} from '@/store/user'

export const useDefaultCustomer = () => {
  const userStore = useUserStore()

  const isDefaultCustomer = computed(() => {
    return userStore.loggedIn && userStore.loadedCustomerUuid === 'default'
  })

  return {
    isDefaultCustomer
  }
}
